import { combineReducers } from "redux";

import { accountantConstants } from "../actions/deadlines/accountant";
import { companyConstants } from "../actions/deadlines/company";

const defaultState = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: ""
    }
  },
  deadlines: [],
  next: null
};

function effectiveOrNot(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case accountantConstants.GET_EFFECTIVE_OR_NOT_CLEAR:
    return defaultState;
  case accountantConstants.GET_EFFECTIVE_OR_NOT_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      },
      deadlines: defaultS.deadlines,
      next: payload.isReset ? null : defaultS.next,
      isGettingEffective: true
    };
  case accountantConstants.GET_EFFECTIVE_OR_NOT_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      deadlines: payload.isReset ? payload.data._embedded.deadlines : defaultS.deadlines.concat(payload.data._embedded.deadlines),
      next: payload.data._links ? payload.data._links.next : null,
      isGettingEffective: false
    };
  case accountantConstants.GET_EFFECTIVE_OR_NOT_ERROR:
    return {
      ...defaultS,
      status: {
        started: false,
        error: true,
        ended: false
      },
      deadlines: defaultS.deadlines,      
      isGettingEffective: false
    };
  case companyConstants.SET_DEADLINES_ARCHIVED_SUCCESS:
    
    let newDeadlines = [];
    defaultS.deadlines.map((item) => {      
      if (payload.id === item.id) {
        if (payload.archived && payload.showArchived === false) {
          return null;
        }
        return newDeadlines.push({
          ...item,
          status: { ...item.status, archived: payload.archived }
        });
      }
      return newDeadlines.push(item);
    });
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      deadlines: newDeadlines,
      next: defaultS.next
    };
  default:
    return defaultS;
  }
}

function deadlinesCounterparts(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? null : state;
  switch (type) {
  case accountantConstants.GET_DEADLINES_COUNTERPARTS_SUCCESS:
    return payload.data;
  case accountantConstants.GET_DEADLINES_COUNTERPARTS_START:
    return [];
  case accountantConstants.GET_DEADLINES_COUNTERPARTS_ERROR:
    return payload;
  default:
    return defaultS;
  }
}

function filtersActive(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? null : state;
  switch (type) {
  case accountantConstants.GET_EFFECTIVE_OR_NOT_SUCCESS:    
    return payload?.isFiltersActiveToUpdate ? payload?.queryParameters : (state?.filtersActive || null) ;
  default:
    return defaultS;
  }
}

function merge(state, { type, payload }) {
  let defaultS =
    typeof state === "undefined"
      ? {
        isSavingMerge: false,
        error: false
      }
      : state;
  switch (type) {
  case accountantConstants.CREATE_MERGED_DEADLINE_START:
    return {
      isSavingMerge: true,
      error: false
    };
  case accountantConstants.CREATE_MERGED_DEADLINE_SUCCESS:
    return {
      isSavingMerge: false,
      error: false
    };
  case accountantConstants.CREATE_MERGED_DEADLINE_ERROR:
    return {
      isSavingMerge: false,
      error: true
    };
  default:
    return defaultS;
  }
}

export const deadlinesAccountant = combineReducers({
  effectiveOrNot,
  deadlinesCounterparts,
  filtersActive,
  merge
});

export default deadlinesAccountant;
